import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  selectWrapper: {
    position: "relative",
    border: `1px solid ${colour.grey[500]}`,
    //borderRadius: 30,
    //padding: "7px 0 0 20px",

    marginBottom: 20,
    color: colour.grey[400],
    fontSize: 16,
    display: "flex",
    // border: `1px solid rgb(219, 225, 219)`,
    borderRadius: 500,
    padding: "12px 20px",
    marginBottom: 20,
    width: "100%",
    fontSize: 16,
    color: "rgb(92, 98, 92)",
    background: "#fff",
  },
  title: {
    display: "block",
    fontWeight: 400,
  },
  hideOnMobile: {
    '@media(max-width: 420px)': {
      display: "none",
    }
  },
  select: {
    appearance: "none",
    width: "100%",
    border: 0,
    background: 0,
    fontSize: 18,
    fontWeight: 600,
    color: colour.grey[200],
    // top: -10,
    // padding: "28px 130px 10px 10px",
    position: "relative",
    // margin: "-18px -11px",
    cursor: "pointer",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    textOverflow: "ellipsis",

    "::-ms-expand": {
      display: "none",
    },
    ":hover": {
      outline: 0,
    },
    ":focus": {
      outline: 0,
    },
  },
  changeText: {
    textDecoration: "underline",
  },
  arrow: {
    position: "absolute",
    right: 20,
    top: "50%",
    marginTop: "-10px",
    marginLeft: "auto",
    color: colour.grey[300],
    pointerEvents: "none",
    ":after": {
      fontFamily: "informetis",
      fontWeight: 600,
      content: '"\\f107"',
      paddingLeft: 10,
    },
  },
  arrowCenter: {
    top: "50%",
    marginTop: -13,
  },
  timeSelectWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  timeButton: {
    padding: "10px 20px",
    display: "block",
    color: "#ffffff",
    textDecoration: "none",
    textAlign: "center",
    fontWeight: 700,
    fontSize: 18,
    border: 0,
    borderRadius: 30,
    cursor: "pointer",
    background: colour.brand.green,
    ":disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
  timeButtonIcon: {
    marginRight: 10,
  },
  timeButtonIconRight: {
    marginLeft: 10,
  },
});
